import { __extends } from "tslib";
import * as React from 'react';
import { SelectTilePadding } from '..';
import { Icon } from '../../icon/icon';
import { Tooltip } from '../../tooltip/tooltip';
import { checkMark } from '../../../icons/processed';
import { classNames } from '@wix/answers-lib';
export var InternalSelectTileKey = 'internal-select-tile';
var InternalSelectTile = /** @class */ (function (_super) {
    __extends(InternalSelectTile, _super);
    function InternalSelectTile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.onChange = function () { return !_this.props.disabled ? _this.props.onSelect() : null; };
        return _this;
    }
    InternalSelectTile.prototype.render = function () {
        var props = this.props;
        var cn = classNames('tile-container', { checked: props.checked }, { disabled: !!props.disabled });
        var paddingSize = props.padding ? props.padding : SelectTilePadding.NONE;
        var comp = (React.createElement("div", { onClick: this.onChange, className: cn, style: { padding: paddingSize } },
            props.checked ? React.createElement(Icon, { className: 'checked-icon', icon: checkMark }) : null,
            props.children));
        return (React.createElement("div", { className: InternalSelectTileKey }, props.disabled ? React.createElement(Tooltip, { body: props.disabled }, comp) : comp));
    };
    return InternalSelectTile;
}(React.PureComponent));
export { InternalSelectTile };
//# sourceMappingURL=index.js.map